import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";

const SoftApprovalList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [approvals, setApprovals] = useState([]);

  const customerId = queryParams.get("customerId") || "";
  const loanId = queryParams.get("loanId") || "";

  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});

  // ⭐ ADDED: Product list
  const [products, setProducts] = useState([]);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const showToastMsg = (msg) => {
    setToastMessage(msg);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2500);
  };

  const fetchSoftApprovals = () => {
  const query = [];
  if (customerId) query.push(`customerId=${customerId}`);
  if (loanId) query.push(`loanId=${loanId}`);

  const queryString = query.length ? `?${query.join("&")}` : "";

  axiosInstance
    .get(`${URL.SoftApprovalList}${queryString}`)
    .then((res) => setApprovals(res.data))
    .catch((err) => console.error(err));
};


  useEffect(() => {
    fetchSoftApprovals();

    // ⭐ ADDED: Fetch product list
    axiosInstance
      .get(URL.PRODUCT_LIST)
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Error loading product list:", err));

  }, []);

  const openEditModal = (item) => {
    setEditData({
      customerId: item.customerId,
      loanId: item.loanId,
      roi: item.roi,
      tenure: item.tenure,
      softApprovalAmount: item.softApprovalAmount,

      // ⭐ ADDED: productId inside edit modal (existing may not have value)
      productId: item.productId || "",
    });
    setShowEditModal(true);
  };

  const handleEditSave = () => {
    axiosInstance
      .post(URL.EDIT_SOFT_APPROVAL, editData)
      .then(() => {
        showToastMsg("Updated Successfully");

        setApprovals((prev) =>
          prev.map((item) =>
            item.customerId === editData.customerId &&
            item.loanId === editData.loanId
              ? { ...item, ...editData }
              : item
          )
        );

        setShowEditModal(false);
      })
      .catch(() => showToastMsg("Error updating record"));
  };

 const handleUpdate = (custId, lnId, isApproved) => {
  axiosInstance
    .post(`${URL.SoftApprovalList}/update`, null, {
      params: { customerId: custId, loanId: lnId, isApproved },
    })
    .then((res) => {
      showToastMsg(res.data.message);

      setApprovals((prev) =>
        prev.map((item) =>
          item.customerId === custId && item.loanId === lnId
            ? { ...item, isApproved }
            : item
        )
      );
    })
    .catch(() => showToastMsg("Error updating soft approval"));
};


 const handleCreditOfficerApprove = (customerId) => {
  axiosInstance
    .post(`${URL.UPDATE_STEP_STATUS}?customerId=${customerId}`)
    .then(() => {
      showToastMsg("Approved by Credit Officer");
      fetchSoftApprovals();
    })
    .catch((err) => {
      if (
        err?.response?.data?.message?.toLowerCase()?.includes("already") ||
        err?.response?.status === 409
      ) {
        showToastMsg("Already approved");
      } else {
        showToastMsg("Already approved");
      }
    });
};


  const handleBack = () => navigate(-1);

  return (
    <div className="container mt-4">

      {/* Toast */}
      {showToast && (
        <div
          className="toast align-items-center text-white bg-success border-0 show"
          style={{ position: "fixed", top: 20, right: 20, zIndex: 9999 }}
        >
          <div className="d-flex">
            <div className="toast-body">{toastMessage}</div>
          </div>
        </div>
      )}

      <div className="mb-3">
        <button className="btn btn-secondary" onClick={handleBack}>
          ← Back
        </button>
      </div>

      <h4>Soft Approval List</h4>

      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Customer Name</th>
            <th>Loan ID</th>
            <th>Soft Approval Amount</th>
            <th>ROI</th>
            <th>Tenure</th>
            <th>Status</th>
            <th>Verify & Update</th>
            <th>Approval By Credit Officer</th>
          </tr>
        </thead>

        <tbody>
          {approvals.length ? (
            approvals.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.customerName || "-"}</td>
                <td>{item.loanId}</td>
                <td>{item.softApprovalAmount}</td>
                <td>{item.roi}</td>
                <td>{item.tenure}</td>

                {/* Status */}
                <td>
                  {item.isApproved === 1
                    ? "Approved"
                    : item.isApproved === 0
                    ? "Rejected"
                    : "Pending"}
                </td>

                {/* Verify & Update */}
                <td>
                  {item.isApproved === 1 ? (
                    <span className="approve">Approved</span>
                  ) : (
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => openEditModal(item)}
                    >
                      Edit
                    </button>
                  )}
                </td>

                {/* Credit Officer Approve */}
                <td>
                  {item.isApproved === 1 ? (
                    <span className="approve">Approved</span>
                  ) : item.creditOfficerStatus === 1 ? (
                    <span className="approve">Approved</span>
                  ) : (
                    <button
                      className="btn btn-info btn-sm"
                      onClick={() =>
                        handleCreditOfficerApprove(item.customerId)
                      }
                    >
                      Approve
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Edit Soft Approval</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <label>ROI</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editData.roi}
                    onChange={(e) =>
                      setEditData({ ...editData, roi: e.target.value })
                    }
                  />
                </div>

                <div className="mb-2">
                  <label>Tenure</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editData.tenure}
                    onChange={(e) =>
                      setEditData({ ...editData, tenure: e.target.value })
                    }
                  />
                </div>

                <div className="mb-2">
                  <label>Soft Approval Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editData.softApprovalAmount}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        softApprovalAmount: e.target.value,
                      })
                    }
                  />
                </div>

                {/* ⭐ ADDED PRODUCT DROPDOWN */}
                <div className="mb-2">
                  <label>Product</label>
                  <select
                    className="form-control"
                    value={editData.productId}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        productId: e.target.value,
                      })
                    }
                  >
                    <option value="">-- Select Product --</option>

                    {products.map((p) => {
                      const repay =
                        p.repaymentType === 1
                          ? "EDI"
                          : p.repaymentType === 4
                          ? "Bullet"
                          : "Unknown";

                      return (
                        <option key={p.id} value={p.id}>
                          ₹{p.loanAmount} • ROI {p.interestRate}% • Proc Fee{" "}
                          {p.processFee} • {repay}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleEditSave}
                >
                  Save Changes
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SoftApprovalList;